module.exports = __webpack_public_path__ + "img/gold4.175f23a2.png";